import { z } from 'zod';
export const ErrorCode = {
    // Auth
    AUTH_REQUIRED: 'AUTH_REQUIRED',
    AUTH_INVALID: 'AUTH_INVALID',
    AUTH_EXPIRED: 'AUTH_EXPIRED',
    API_KEY_INVALID: 'API_KEY_INVALID',
    API_KEY_LIMIT: 'API_KEY_LIMIT',
    // Billing
    QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
    PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
    CYCLE_EXPIRED: 'CYCLE_EXPIRED',
    PLAN_QUALITY_NOT_ALLOWED: 'PLAN_QUALITY_NOT_ALLOWED',
    // Rate limiting
    RATE_LIMITED: 'RATE_LIMITED',
    UPSTREAM_RATE_LIMITED: 'UPSTREAM_RATE_LIMITED',
    // Generation
    GENERATION_FAILED: 'GENERATION_FAILED',
    CONTENT_VIOLATION: 'CONTENT_VIOLATION',
    CONTENT_POLICY_VIOLATION: 'CONTENT_POLICY_VIOLATION',
    MODEL_UNAVAILABLE: 'MODEL_UNAVAILABLE',
    UPSTREAM_TIMEOUT: 'UPSTREAM_TIMEOUT',
    UPSTREAM_UNAVAILABLE: 'UPSTREAM_UNAVAILABLE',
    PIPELINE_STAGE1_FAILED: 'PIPELINE_STAGE1_FAILED',
    PIPELINE_STAGE2_FAILED: 'PIPELINE_STAGE2_FAILED',
    PIPELINE_ALL_FAILED: 'PIPELINE_ALL_FAILED',
    // Stripe
    STRIPE_WEBHOOK_INVALID: 'STRIPE_WEBHOOK_INVALID',
    // Billing management
    SAME_PLAN: 'SAME_PLAN',
    NO_ACTIVE_PLAN: 'NO_ACTIVE_PLAN',
    // Editor sessions
    EDIT_SESSION_EXPIRED: 'EDIT_SESSION_EXPIRED',
    EDIT_SESSION_NOT_FOUND: 'EDIT_SESSION_NOT_FOUND',
    EDIT_SESSION_INVALID_STATE: 'EDIT_SESSION_INVALID_STATE',
    EDIT_NONCE_INVALID: 'EDIT_NONCE_INVALID',
    EDIT_HMAC_MISMATCH: 'EDIT_HMAC_MISMATCH',
    // Abuse detection
    DISPOSABLE_EMAIL_BLOCKED: 'DISPOSABLE_EMAIL_BLOCKED',
    SIGNUP_IP_LIMIT_REACHED: 'SIGNUP_IP_LIMIT_REACHED',
    ABUSE_THROTTLED: 'ABUSE_THROTTLED',
    // GDPR
    ACCOUNT_PENDING_DELETION: 'ACCOUNT_PENDING_DELETION',
    ACCOUNT_RESTRICTED: 'ACCOUNT_RESTRICTED',
    GDPR_EXPORT_FAILED: 'GDPR_EXPORT_FAILED',
    GDPR_DELETION_FAILED: 'GDPR_DELETION_FAILED',
    // Infrastructure
    INVALID_IDEMPOTENCY_KEY: 'INVALID_IDEMPOTENCY_KEY',
    SERVICE_DEGRADED: 'SERVICE_DEGRADED',
    // General
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    PAYLOAD_TOO_LARGE: 'PAYLOAD_TOO_LARGE',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    IDEMPOTENCY_CONFLICT: 'IDEMPOTENCY_CONFLICT',
};
export const ErrorCodeSchema = z.enum(Object.values(ErrorCode));
//# sourceMappingURL=errors.js.map